import { MenuOutlineIcon } from '@ikyucom/design-system-icons-react'
import { useCallback, useState } from 'react'
import { twMerge } from 'tailwind-merge'
import SideMenu from '~/components/sideMenu/sd/SideMenu'
import { useBackgroundFix } from '~/hooks/useBackgroundFix'
import { css } from '~/styled-system/css'

export function SideMenuContainer({ className = '' }: { className?: string }) {
  const { opened, open, close } = useSideMenu()
  return (
    <>
      <div className={twMerge('flex flex-row items-center justify-end', className)}>
        <MenuOutlineIcon
          width={26}
          height={26}
          className={css({ color: 'primary' })}
          onClick={open}
        />
      </div>
      <SideMenu show={opened} close={close} />
    </>
  )
}

function useSideMenu() {
  const [opened, setOpened] = useState(false)
  useBackgroundFix(opened)

  const open = useCallback(() => {
    setOpened(true)
  }, [])

  const close = useCallback(() => {
    setOpened(false)
  }, [])

  return { opened, open, close }
}
